import store from '@/store';
import { colors } from '@/globalStyles';
import { isColorPrinterAvailable } from './printers';

export default () => {
  const { core: { pages, printerList } } = store.getState();
  const isBLUEMARKPrinterAvailable = isColorPrinterAvailable(printerList);
  const blackAndWhiteColors = [colors.black, colors.white];
  if (isBLUEMARKPrinterAvailable) {
    const isColoredColorAvailable = Object.values(pages).some(({ sections }) => {
      return Object.values(sections).some(({ fontColor, shapeFillColor, shapeStrokeColor, image }) => {
        const isFontColorColored = !blackAndWhiteColors.includes(fontColor);
        const isShapeFillColored = !blackAndWhiteColors.includes(shapeFillColor);
        const isShapeStrokeColored = !blackAndWhiteColors.includes(shapeStrokeColor);
        const isImageColored = !!image?.source;
        return isFontColorColored || isShapeFillColored || isShapeStrokeColored || isImageColored;
      });
    });
    if (isColoredColorAvailable) {
      return 'Y';
    }
  }
  return 'N';
};
